export default "__VITE_PUBLIC_ASSET__41b3eeae__"